module.exports = __webpack_public_path__ + "static/media/slide (5).d7d401bc.jpg";